import {i18n} from '@yourcoach/i18n';

import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

import {not} from '../../conditionalUtils';
import {envManager} from '../../env';
import {isDefined} from '../../typecheck';
import {isChatConference as isChatConferenceUtil} from './isChatConference';
import {isConferenceCreatedByClient} from './isConferenceCreatedBy';

export const getConferenceTitle = (
  conference?: Nullable<ConferenceApiModel>,
) => {
  if (isDefined(conference)) {
    const isChatConference = isChatConferenceUtil(conference);

    if (envManager.isB2bWidget) {
      if (isChatConference) {
        return i18n.t('shared:real_time_chat_session');
      }

      return i18n.t('shared:live_session');
    }

    const isBookedByClient = isConferenceCreatedByClient(conference);
    const isInCourse = isDefined(conference.course_id);
    const isIntroCall = isBookedByClient && not(isInCourse);
    const isClientConference = isBookedByClient && isInCourse;

    if (isIntroCall) {
      return i18n.t('shared:intro_call');
    }

    if (isClientConference) {
      if (isChatConference) {
        return i18n.t('shared:real_time_chat_session');
      }

      return i18n.t('shared:live_session');
    }

    return conference.title;
  }

  return '';
};
